import React from 'react';
import styles from '../../ManageDealDrawer.module.scss';
import { useManageDealDrawerFooter } from './useManageDealDrawerFooter';

interface ManageDealDrawerFooterProps {
    currentConfig: any;
    disablePrimary: boolean;
    onPrimary: () => Promise<void>;
    onSecondary: () => void;
    disableSecondary: boolean;
    style?: React.CSSProperties;
    totalSteps?: number;
    currentStep?: number;
    onProceed?: () => void;
    onShowDismissalAlert?: () => void;
}

export const ManageDealDrawerFooter: React.FC<ManageDealDrawerFooterProps> = ({
    currentConfig,
    disablePrimary,
    onPrimary,
    onSecondary,
    disableSecondary,
    style,
    totalSteps = 1,
    currentStep = 1,
    onProceed,
    onShowDismissalAlert,
}) => {
    if (!currentConfig?.ctas) return null;

    const { isSubmitting, isLastStep, handlePrimaryClick, getPrimaryButtonText } = useManageDealDrawerFooter({
        totalSteps,
        currentStep,
        onSave: onPrimary,
        onNext: onProceed,
        onShowDismissalAlert,
        disabled: disablePrimary,
    });

    return (
        <div style={style} className={styles.DrawerFooter}>
            <div className={styles.CtaContainer}>
                {currentConfig.ctas.primary && (
                    <button
                        type={isLastStep ? 'submit' : 'button'}
                        disabled={disablePrimary || isSubmitting}
                        onClick={handlePrimaryClick}
                        className={`${styles.Button} ${styles.Primary}`}
                    >
                        {getPrimaryButtonText(currentConfig?.ctas?.primary?.text ?? '')}
                    </button>
                )}

                {currentConfig.ctas.secondary && (
                    <button
                        type="button"
                        disabled={disableSecondary}
                        className={`${styles.Button} ${styles.Secondary}`}
                        onClick={onSecondary}
                    >
                        {currentConfig.ctas.secondary.text}
                    </button>
                )}
            </div>
        </div>
    );
};
